<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit"></filter-form>
    <a-table
      ref="datas"
      size="default"
      :bordered="true"
      :columns="columns"
      :data-source="datas"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
      :expandedRow="true"
      rowKey="id"
    >
      <template slot="expandedRowRender" slot-scope="record">
        <a-table
          :rowKey="
            () => {
              return Math.random().toString();
            }
          "
          :columns="innerColumns"
          :data-source="record.orderDetailLists"
        ></a-table>
      </template>
    </a-table>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";
export default {
  mixins: [account, dateFormat, moneyFormat],
  // 接受属性
  props: {
    paramsX: Object
  },
  data() {
    return {
      filter: [
        {
          type: "dateFilter",
          key: "filterTime",
          name: "记账日期"
        },
        {
          type: "select",
          key: "type",
          name: "类型",
          options: [{ name: "订单占用", val: 1 }, { name: "出库占用", val: 2 }]
        }
      ],
      columns: [
        {
          title: "类型",
          width: 150,
          dataIndex: "type",
          sorter: true,
          customRender: (text, row, index) => {
            return row.typeStr;
          }
        },
        {
          title: "平台",
          width: 150,
          dataIndex: "platform",
          customRender: (text, row, index) => {
            return row.platformStr;
          }
        },
        {
          title: "单号",
          width: 150,
          dataIndex: "erpNum",
          customRender: (text, row, index) => {
            return row.platform == 0 ? row.erpNum : row.orderNo;
          }
        },
        {
          title: "记账日期",
          width: 120,
          dataIndex: "occurredTime",
          sorter: true,
          customRender: (text, row, index) => {
            return this.formatDate(row.occurredTime, "YYYY-MM-DD");
          }
        },
        {
          title: "金额",
          width: 150,
          dataIndex: "amount",
          sorter: true
        }
      ],
      innerColumns: [
        {
          title: "产品名",
          width: 200,
          dataIndex: "productName"
        },
        {
          title: "编码",
          width: 100,
          dataIndex: "productCode"
        },
        {
          title: "规格",
          width: 100,
          dataIndex: "specDes"
        },
        {
          title: "是否定制",
          width: 80,
          dataIndex: "isCustom",
          customRender: (text, row, index) => {
            return row.isCustom ? "是" : "否";
          }
        },
        {
          title: "数量",
          width: 80,
          dataIndex: "quantity"
        },
        {
          title: "产品金额",
          width: 80,
          dataIndex: "price"
        },
        {
          title: "备注",
          width: 200,
          dataIndex: "notes"
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { startTime: null, endTime: null, type: null, creditId: 0 },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      creditId: 0
    };
  },
  async mounted() {
    this.creditId = this.paramsX.id;
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.type = p.values.type;
      this.filterdata.startTime =
        p.values.filterTime[0] != null
          ? p.values.filterTime[0].startOf("day").valueOf()
          : null;
      this.filterdata.endTime =
        p.values.filterTime[1] != null
          ? p.values.filterTime[1].startOf("day").valueOf()
          : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(pagination, filters, sorter) {
      console.log("asdasd");
      if (pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        this.maxResultCount = pagination.pageSize;
        this.filterdata.skipCount =
          pagination.current == 1
            ? 0
            : (pagination.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = pagination.pageSize;
      }
      if (sorter.field) {
        this.filterdata.sorting =
          sorter.field + " " + (sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      options.creditId = this.creditId;
      let data = await api.GetOccupyCreditDetailList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
tr.ant-table-expanded-row td > .ant-table-wrapper {
  margin: -5px -5px -5px;
}
</style>



// WEBPACK FOOTER //
// src/router/Basic/Credit/OccupyDetailList.vue